import { render, staticRenderFns } from "./HomeMfe.vue?vue&type=template&id=6d84e5a8&scoped=true"
import script from "./HomeMfe.vue?vue&type=script&lang=js"
export * from "./HomeMfe.vue?vue&type=script&lang=js"
import style0 from "./HomeMfe.vue?vue&type=style&index=0&id=6d84e5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84e5a8",
  null
  
)

export default component.exports